import React from 'react';

const NewTwitterIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3 21.0001L10.5484 13.4517M10.5484 13.4517L3 3.00012H8L13.4516 10.5485M10.5484 13.4517L16 21.0001H21L13.4516 10.5485M21 3.00012L13.4516 10.5485",
      stroke: "white",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
NewTwitterIcon.displayName = "Icons.NewTwitterIcon";

export { NewTwitterIcon };
//# sourceMappingURL=NewTwitterIcon.js.map
